import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import '../Css/Global/Global.css';
import {getToken} from "../Storages/cookies";

const PrivateRoute: React.FC = () => {
    const isAuthenticated = getToken();

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    return <Outlet />;
};

export default PrivateRoute;
